import { Box, Group, Stack, Text, useMantineTheme } from "@mantine/core";
import { EntityCardProps, ValuesObject } from "@mcurros2/microm";
import { IconAlertCircle, IconBuildingStore, IconChecklist, IconCircleCheck, IconHelpCircle, IconInfoCircle, IconUserCheck } from "@tabler/icons-react";

export interface DatosServiciosAutorizacionCardData extends ValuesObject {
    c_visita_id: string,
    vc_titulo_registro: string,
    vc_clientes: string,
    vc_tienda: string,
    vc_personal: string,
    d_fecha_visita: Date,
    vc_total_autorizaciones: string,
    vc_total_pendientes: string,
    vc_total_autorizadas: string,
    vc_total_rechazadas: string
}

export function DatosServiciosAutorizacionCard(props: EntityCardProps<ValuesObject>) {
    const {
        entity, record
    } = props;

    const data = record.data as DatosServiciosAutorizacionCardData;

    const theme = useMantineTheme();
    const iconColor = theme.colorScheme === "dark" ? theme.colors.dark[3] : theme.colors.gray[5];
    const warningColor = theme.colorScheme === "dark" ? theme.colors.orange[5] : theme.colors.orange[7];
    const okColor = theme.colorScheme === "dark" ? theme.colors.green[5] : theme.colors.green[7];
    const errorColor = theme.colorScheme === "dark" ? theme.colors.red[5] : theme.colors.red[7];

    return (
        <Box mih="13rem" w="20rem">
            <Text fz="lg" align="center" fw={500} mb="xs" color='dimmed'>{data.vc_titulo_registro}</Text>
            <Group noWrap align="flex-start">
                <Stack spacing={1}>
                    <Group noWrap spacing={10}>
                        <IconBuildingStore stroke={1.5} size="1.5rem" color={iconColor} />
                        <Text fz="xs" c="dimmed">
                            Tienda: {data.vc_tienda}
                        </Text>
                    </Group>
                    <Group noWrap spacing={10}>
                        <IconUserCheck stroke={1.5} size="1.5rem" color={iconColor} />
                        <Text fz="xs" c="dimmed">
                            Clientes: {data.vc_clientes}
                        </Text>
                    </Group>
                    <Group noWrap spacing={10}>
                        <IconInfoCircle stroke={1.5} size="1.5rem" color={iconColor} />
                        <Text fz="xs" c="dimmed">
                            Fecha: {data.d_fecha_visita.toString()}
                        </Text>
                    </Group>
                    <Group noWrap spacing={10}>
                        <IconChecklist stroke={1.5} size="1.5rem" color={iconColor} />
                        <Text fz="xs" c="dimmed">
                            Autorizaciones: {data.vc_total_autorizaciones}
                        </Text>
                    </Group>
                    <Group noWrap spacing={10}>
                        <IconHelpCircle stroke={1.5} size="1.5rem" color={warningColor} />
                        <Text fz="xs" c="dimmed">
                            Pendientes: {data.vc_total_pendientes}
                        </Text>
                    </Group>
                    <Group noWrap spacing={10}>
                        <IconCircleCheck stroke={1.5} size="1.5rem" color={okColor} />
                        <Text fz="xs" c="dimmed">
                            Autorizadas: {data.vc_total_autorizadas}
                        </Text>
                    </Group>
                    <Group noWrap spacing={10}>
                        <IconAlertCircle stroke={1.5} size="1.5rem" color={errorColor} />
                        <Text fz="xs" c="dimmed">
                            Rechazadas: {data.vc_total_rechazadas}
                        </Text>
                    </Group>
                </Stack>
            </Group>
        </Box>
    )
}